import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import Testimonials from '../../../components/Testimonials/Testimonials';
import Reasons from '../../../components/Reasons/Reasons';
// import Ratings from '../../../components/Ratings/Ratings.jsx';

class General extends Component {
  componentDidMount () {
    this.props.toggleInQuiz(false);
    this.props.toggleInResults(false);
    this.props.setStep(1);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - General',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <Reasons classes='divider p60' headline='true' chp='true' />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=Child Health Plus' />
        <Testimonials heading='&ldquo;I don&rsquo;t know what I would have done without CDPHP.&rdquo;' slides='general'>
          <p className='text-center'><Link to='/find-a-plan/' className='btn alt lg'>Find a Plan</Link></p>
        </Testimonials>
      </Aux>
    );
  }
}

General.propTypes = { // validate props expected
};

export default General;



// WEBPACK FOOTER //
// ./src/containers/Views/Landing/General.jsx